import { computed, onUnmounted, ref, watch, type Ref } from 'vue'
import { onKeyStroke } from '@vueuse/core'
import { defineStore } from 'pinia'

const useTargetsStore = defineStore('targetsStore', () => {
    let baseId = 0
    const targets = ref<number[]>([])
    const last = computed(() => targets.value[targets.value.length - 1])

    const createId = () => {
        baseId += 1
        const id = baseId
        targets.value.push(id)

        return id
    }

    const removeIfLast = (id: number): boolean => {
        if (last.value === id) {
            targets.value.pop()

            return true
        } else {
            return false
        }
    }

    const clear = (id: number) => {
        const index = targets.value.indexOf(id)

        if (index !== -1) {
            targets.value.splice(index, 1)
        }
    }

    return {
        targets,
        createId,
        last,
        removeIfLast,
        clear,
    }
})

export function useHandleEscapeKey(
    handler: () => void,
    isOpen?: Readonly<Ref<boolean>>
): void {
    const { createId, removeIfLast, clear } = useTargetsStore()

    let id: number

    onKeyStroke('Escape', (e) => {
        e.preventDefault()
        e.stopPropagation()

        if (removeIfLast(id)) {
            handler()
        }
    })

    if (isOpen !== undefined) {
        watch(
            isOpen,
            (newValue) => {
                if (newValue) {
                    id = createId()
                } else {
                    clear(id)
                }
            },
            { immediate: true }
        )
    } else {
        id = createId()
    }

    onUnmounted(() => clear(id))
}
